import { render, staticRenderFns } from "./InsurerSpecialRates.vue?vue&type=template&id=55bcc211"
import script from "./InsurerSpecialRates.vue?vue&type=script&lang=js"
export * from "./InsurerSpecialRates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55bcc211')) {
      api.createRecord('55bcc211', component.options)
    } else {
      api.reload('55bcc211', component.options)
    }
    module.hot.accept("./InsurerSpecialRates.vue?vue&type=template&id=55bcc211", function () {
      api.rerender('55bcc211', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurer/InsurerSpecialRates.vue"
export default component.exports